import { createContext, useContext } from 'react';
export const ReportingContext = createContext(null);
export const useReporting = () => useContext(ReportingContext);
